import React ,{ useEffect, useState} from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Footer from "../../components/Footer";
import { useParams,useNavigate, Link } from "react-router-dom";
import { stringify } from "querystring";
import { useDispatch, useSelector } from "react-redux";
import { OrderDetailAction } from "../../redux/actions/UserActions";
import { Helmet } from 'react-helmet';
import { customFormat} from "../../utils/Helper";
import './order_details.css';

type SeoContent = {
  meta_title: string;
  meta_description?: string;
  // Add more fields as needed
};

type OrderDetail = {
  order_id: string;
  status: string;
  message?: string;
  [key: string]: any; // allow extra fields
};

const OrderDetails: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    console.log("ID : ",id)
    const dispatch = useDispatch<any>();
    const [soeContent, setSoeContent] = useState<SeoContent | null>(null);
    const [dataDetails, setDataDetail] = useState<OrderDetail | null>(null);
    //const [loading, setLoading] = useState<boolean>(true);
    const {data ,status , loading, error} = useSelector((state: any) => state.orderDetailState || []);

    useEffect(() => {
      dispatch(OrderDetailAction({'detail_id':id}));
    }, [dispatch])


    useEffect(() => {
      console.log("Orders : " , data);
      if ( status && data?.data) {
        setDataDetail(data?.data);
      }
    }, [status,data])

  return (
    <>
    <Helmet>
      <title>{`${soeContent?.meta_title || 'Order Details'}`}</title>
      <meta name="title" content={soeContent?.meta_title || 'Order Details'} />
      <meta name="description" content={soeContent?.meta_description || 'Learn with curated e-learning resources'} />
      <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials" />
    </Helmet>

      <Header />

      <div className="container py-5">
          <div className="row">

                <Sidebar />

                <div className="col-lg-9">
                    <div className="main-content">

                      <div className="page-header">
                        <Link className="back-button desktop-back-btn" to={"/my-orders"}><i className="bi bi-arrow-left me-2"></i>Back to Orders</Link>
                        <div className="container">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h1 className="fw-bold mb-3">Order Details</h1>
                              <p className="lead mb-0">Order {dataDetails?.order_id}</p>
                            </div>
                            <span className="order-status status-completed">Completed</span>
                          </div>
                        </div>
                      </div>

                      <h2 className="mb-4">Order Information</h2>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                          <div className="filter-buttons">
                              
                          </div>
                      </div>

                      <div className="row">
                        {/* Order Details Column */}
                        <div className="col-lg-12 mb-4">
                          <div className="">

                            <div className="row mb-4">
                              <div className="col-md-6">
                                <h5 className="fw-semibold mb-3">Order Details</h5>
                                <div className="mb-2">
                                  <span className="text-muted">Order Number:</span>
                                  <strong className="ms-2">#{dataDetails?.order_id}</strong>
                                </div>
                                <div className="mb-2">
                                  <span className="text-muted">Order Date:</span>
                                  <strong className="ms-2">{dataDetails?.created_at}</strong>
                                </div>
                                <div className="mb-2">
                                  <span className="text-muted">Order Status:</span>
                                  <strong className="ms-2">Completed</strong>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <h5 className="fw-semibold mb-3">Payment Information</h5>
                                <div className="mb-2">
                                  <span className="text-muted">Payment Method:</span>
                                  <strong className="ms-2">{dataDetails?.payment_method}</strong>
                                </div>
                                <div className="mb-2">
                                  <span className="text-muted">Transaction ID:</span>
                                  <strong style={{wordWrap:'break-word'}} className="ms-2">{dataDetails?.transaction_id}</strong>
                                </div>
                                <div>
                                  <span className="text-muted">Payment Status:</span>
                                  <strong className="ms-2">{dataDetails?.payment_status}</strong>
                                </div>
                              </div>
                            </div>

                            <h5 className="fw-semibold mb-3">Amount Information</h5>
                            <div className="row mb-4">
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <span className="text-muted">Amount:</span>
                                  <strong className="ms-2">{dataDetails?.currency} {dataDetails?.amount}</strong>
                                </div>
                              </div>
                            </div>

                            <h5 className="fw-semibold mb-3">Order Items</h5>
                            <div className="timeline">
                              <div className="timeline-item">

                                <div className="row">
                                  <div className="col-md-8">
                                        {dataDetails?.orders && dataDetails?.orders?.length > 0 ? (
                                          dataDetails?.orders.map((order: any) => (
                                            <div className="course-item" key={order?.id}>
                                              <span className="cart-custom-icon">
                                                {order?.category?.icon}
                                              </span>
                                              <div className="course-item-details">
                                                <h5 className="course-item-title">{order?.category?.name}</h5>
                                                <p className="course-item-instructor">{order?.category?.single_line}</p>
                                                <div className="d-flex align-items-center">
                                                  <span className="badge bg-success me-2">{order?.groups?.name}</span>
                                                </div>
                                              </div>
                                              <div style={{marginTop:'75px'}} className="course-item-price">{order?.currency} {order?.price}</div>
                                            </div>
                                          ))
                                        ) : null}
                                  </div>
                                </div>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                </div>

          </div>
      </div>



      <Footer />
    </>
  );
};

export default OrderDetails;
